import { Theme, css, keyframes } from '@emotion/react';

import { Radius } from 'chatie-design-system';

import { CSSProps } from '../../utils/misc';

const skeletonKeyframe = (fromColor: string, toColor: string) => keyframes`
  from {
    background-color: ${fromColor};
  }

  to {
    background-color: ${toColor};
  }
`;

const frameCSS = (theme: Theme) => css`
  background-color: ${theme.var.gray100};
  border-radius: ${Radius.small}px;
  animation: ${skeletonKeyframe(theme.var.gray100, theme.var.gray200)} 2s
    alternate infinite ease-in-out;
`;

const Frame = ({ className }: CSSProps) => {
  return <div css={frameCSS} className={className} />;
};

export default Frame;
